import {Howl} from "howler";
import { GameManager } from "../GameManager";
import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { AudioManager } from "../AudioManager";

export class PreloadScene extends Phaser.Scene {

    public static currentInstance: PreloadScene;

    private progressBar: Phaser.GameObjects.Graphics;

    constructor() {

        super("PreloadScene");
    }

    public preload(): void {

        this.composeScene();

        this.loadAssets();
    }

    public create(): void {

        PreloadScene.currentInstance = this;

        GameManager.setCurrentScene(this);

        this.loadHowl();
    }

    private updateLoadedPercentage(file: any, percentageLoaded: number): void {

        this.progressBar.clear();
        this.progressBar.fillStyle(0xA6F834);
        this.progressBar.fillRect(0, GameConstants.GAME_HEIGHT - 6, percentageLoaded * GameConstants.GAME_WIDTH, 6);
    }

    private composeScene(): void {

        const tmpBackground = this.add.graphics();
        tmpBackground.fillStyle(0x131538);
        tmpBackground.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);

        this.progressBar = this.add.graphics();

        const loadingLabel = new Phaser.GameObjects.Text(this, 5, GameConstants.GAME_HEIGHT - 45 * GameVars.scaleY, GameVars.languages[GameVars.gameData.language]["LOADING"] + " ...", {fontFamily: "Sarpanch-Black", fontSize: "30px", color: "#7efdff"});
        loadingLabel.setScale(1, GameVars.scaleY);
        loadingLabel.setShadow(0, 0, "#7A6F834", 7.5, true, true);
        this.add.existing(loadingLabel);
    }

    private loadAssets(): void {

        this.load.atlas("texture_atlas_1", "assets/texture_atlas_1.png", "assets/texture_atlas_1.json");

        this.load.atlas("texture_atlas_2_en", "assets/texture_atlas_2_en.png", "assets/texture_atlas_2_en.json");
        this.load.atlas("texture_atlas_2_es", "assets/texture_atlas_2_es.png", "assets/texture_atlas_2_es.json");
        this.load.atlas("texture_atlas_2_de", "assets/texture_atlas_2_de.png", "assets/texture_atlas_2_de.json");
        this.load.atlas("texture_atlas_2_br", "assets/texture_atlas_2_br.png", "assets/texture_atlas_2_br.json");
        this.load.atlas("texture_atlas_2_it", "assets/texture_atlas_2_it.png", "assets/texture_atlas_2_it.json");
        this.load.atlas("texture_atlas_2_ru", "assets/texture_atlas_2_ru.png", "assets/texture_atlas_2_ru.json");
        this.load.atlas("texture_atlas_2_fr", "assets/texture_atlas_2_fr.png", "assets/texture_atlas_2_fr.json");

        this.load.json("audiosprite", "assets/audio/audiosprite.json");
        
        this.load.on("fileprogress", this.updateLoadedPercentage, this);
    }

    private loadHowl(): void {

        let json = this.cache.json.get("audiosprite");
        json = JSON.parse(JSON.stringify(json).replace("urls", "src"));
        json = JSON.parse(JSON.stringify(json).replace("../", ""));
        json = JSON.parse(JSON.stringify(json).replace("../", ""));

        GameVars.currentScene.cache.json.get("audiosprite");

        AudioManager.sound = new Howl(json);

        AudioManager.sound.on("load", function(): void {
            PreloadScene.currentInstance.cameras.main.fadeOut(150, 19, 21, 54);
            PreloadScene.currentInstance.cameras.main.once("camerafadeoutcomplete", function (camera) {
                GameManager.onGameAssetsLoaded();
            });
        });
    }
}
